import React from 'react'
import { useLocation, Link as RouterLink } from 'react-router-dom'
import Typography from '@mui/material/Typography';
import Link  from '@mui/material/Link';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import HomeIcon from '@mui/icons-material/Home';
import { useTranslation } from 'react-i18next';

function toTitleCase(str) {

  return str.replace(/\b\w+/g, function (s) {
    return s.charAt(0).toUpperCase() + s.substr(1).toLowerCase()
  })
}

export default function (props) {
  const { t } = useTranslation(['categoryLabel','common']);
  let location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);
  let parentText = "parent";
  
  if (pathnames.length === 2){
    parentText = t("categoryLabel:CAT_GRP_" + pathnames[0].toUpperCase());
  }

  return (
    <Breadcrumbs aria-label='Breadcrumb' >
      
      
      {(pathnames.length === 0)
      ?
        <Typography variant="h1" color='textPrimary'  sx={{fontWeight: 'bold',fontSize: '1.125rem',color: 'black'}}>
          {t("common:LABEL_CURRENT")}
        </Typography>
      : <Link color='inherit' component={RouterLink} to='/' sx={{textDecoration: 'none'}}>
          <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
        </Link>}
      {pathnames.map((value, index) => {
        const last = index === pathnames.length - 1;
        const to = `/${pathnames.slice(0, index + 1).join('/')}`;

        return last ? (
          <Typography variant="h1" color='textPrimary' key={to} sx={{fontWeight: 'bold',fontSize: '1.125rem',color: 'black'}}>
            {props.lastValue}
          </Typography>
        ) : (
          <Link color='inherit' component={RouterLink} to={to} key={to} sx={{fontSize: '1.125rem',textDecoration: 'none'}}>
            {parentText}
          </Link>
        )
      })}
    </Breadcrumbs>
  )
}